// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 145) return "static/chunks/145-56e4a041ccb2ec08.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 699 ? "5a00b7e4" : chunkId) + "." + {"85":"845a2f8a28f9f8b0","305":"724371dbc67c44d3","699":"376be216f7cb7025"}[chunkId] + ".js";
};